import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=5c076bc3"
import script from "./IconFont.vue?vue&type=script&lang=js"
export * from "./IconFont.vue?vue&type=script&lang=js"
import style0 from "./IconFont.vue?vue&type=style&index=0&id=5c076bc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports